<template>
  <div>
    <b-button variant="danger" block @click.default="logoutAttempt"><i class="icon icon-logout"></i> Cerrar sesión</b-button>

    <b-modal ref="logoutDialog"
        :hide-header="logoutDialog.hideHeader"
        :size="logoutDialog.size"
        :title="logoutDialog.title"
        :ok-title="logoutDialog.okTitle"
        :cancel-title="logoutDialog.cancelTitle"
        @ok="logout">
        <component :is="logoutDialog.component"></component>
    </b-modal>
  </div>
  <!-- <div class="sidebar-footer"></div> -->
</template>
<script>
import {API_BASE} from '../config'

var defaultDialogContent = {
  template: '<p>Mensaje por defecto.</p>'
}

export default {
  name: 'sidebar-footer',

  data () {
    return {
      logoutDialog: {},
      logoutDialogDefaults: {
        hideHeader: false,
        size: 'sm',
        okTitle: 'Aceptar',
        cancelTitle: 'Cancelar',
        component: defaultDialogContent
      }
    }
  },

  methods: {
    logoutAttempt: function () {
      this.logoutDialog = Object.assign(
        this.logoutDialogDefaults,
        {
          title: 'Confirmar acción',
          component: {
            template: '<p>¿Seguro que desea cerrar sesión?</p>'
          }
        }
      )

      this.$refs.logoutDialog.show()
    },

    logout: function () {
      function clearSession () {
        sessionStorage.clear()
        location.reload()
      }

      this.$http.get(API_BASE + 'usuarios/logout')
        .then(clearSession)
        .catch(clearSession)
    }
  }
}
</script>

<style lang="scss">
  .modal-dialog {
    color: #151b1e;
    .modal-header {
      border-bottom: none;
    }
    .modal-footer {
      border-top: none;
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarFooter.vue?26fbf2f0